import React from "react";

/**
 * Renders each validationErrors entry as a bolded key row followed by a
 * bulleted list of the validation messages under that key.
 */
export const renderValidationErrorList = (
  validationErrors: Record<string, string[]>,
) =>
  Object.entries(validationErrors ?? {}).map(([key, messages]) => (
    <div key={key}>
      <strong>{key}</strong>
      <ul>
        {(messages ?? []).map((message, index) => (
          <li key={index}>{message}</li>
        ))}
      </ul>
    </div>
  ));

/**
 * Wraps a failure body (either the per-key error list or a caught error
 * message) with a heading and a separating empty line.
 */
export const failureContent = (
  heading: React.ReactNode,
  body: React.ReactNode,
) => (
  <>
    <div>{heading}</div>
    <br />
    {body}
  </>
);

/**
 * Builds the body for a caught FACD error: a per-key validation list when the
 * error is a FixedFeeValidationException, otherwise the raw error message.
 */
export const facdErrorBody = (error: any): React.ReactNode =>
  error?.name === "FixedFeeValidationException"
    ? renderValidationErrorList(error.errors)
    : error?.message;
